import { HttpClient } from '../../../httpClient'
import { OpalApiRequestBody, OpalApiRequestParams } from '../../../schema'

type DeleteViewBlocksRelationshipParams =
  OpalApiRequestParams<'DeleteViewBlocksRelationshipV3'>
type DeleteViewBlocksRelationshipBody =
  OpalApiRequestBody<'DeleteViewBlocksRelationshipV3'>

type DeleteViewBlocksRelationshipArguments = {
  params: DeleteViewBlocksRelationshipParams
  body: DeleteViewBlocksRelationshipBody
}

export const deleteBlocksRelationship = async ({
  params,
  body,
}: DeleteViewBlocksRelationshipArguments): Promise<null> => {
  const url = new URL(
    `/loupe/v3/views/${params.path.view_id}/relationships/blocks`,
    window.location.origin
  )

  return HttpClient()
    .delete(url.toString(), { data: body })
    .then(() => null)
}
